var _path, _g, _rect, _path2, _circle, _g2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 297,
    viewBox: "0 0 340 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M172.035 11.8484C54.4345 1.63534 14.6406 86.1548 9.44361 129.691C-8.37458 200.888 43.4095 262.755 154.216 269.63C265.023 276.504 291.75 185.667 300.66 166.026C309.569 146.386 319.035 24.6147 172.035 11.8484Z",
    fill: "#FC5726"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_21)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 51,
    width: 126.725,
    height: 235.921,
    rx: 17.5658,
    fill: "#FDDDD1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 51,
    width: 126.725,
    height: 235.921,
    rx: 17.5658,
    stroke: "black",
    strokeWidth: 2.5094
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.386,
    y: 77,
    width: 110,
    height: 185,
    rx: 6,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.51766
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.966 65.4177H171.386",
    stroke: "black",
    strokeWidth: 2.13793
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155.386,
    cy: 275,
    r: 5,
    fill: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_21)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.253,
    y: 65,
    width: 128.747,
    height: 69.1067,
    rx: 34.5533,
    fill: "#FC5726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 133.16C199.632 118.392 200.516 104.287 199.253 99.08L219.426 130.932C216.886 130.472 210.613 120.38 186 133.16Z",
    fill: "#FC5726"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.917 11.0143C168.37 10.2042 169.586 10.3951 169.77 11.3051L170.688 15.8665C171.438 19.586 173.774 22.7925 177.085 24.6449L181.146 26.9167C181.956 27.3699 181.765 28.5864 180.855 28.7697L176.294 29.6884C172.575 30.4376 169.368 32.7742 167.516 36.0854L165.244 40.1461C164.791 40.9563 163.574 40.7654 163.391 39.8553L162.472 35.294C161.723 31.5745 159.386 28.368 156.075 26.5155L152.014 24.2438C151.204 23.7906 151.395 22.5741 152.305 22.3908L156.867 21.4721C160.586 20.7229 163.793 18.3862 165.645 15.075L167.917 11.0143Z",
    fill: "#FC5726"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.103 5.06015C193.76 4.40384 194.878 4.91847 194.807 5.84405L194.309 12.3212C194.018 16.1042 195.394 19.8255 198.077 22.5088L202.67 27.1032C203.326 27.7598 202.811 28.8784 201.886 28.8073L195.409 28.3092C191.626 28.0182 187.904 29.3945 185.221 32.0769L180.627 36.6697C179.97 37.326 178.851 36.8114 178.923 35.8858L179.421 29.4086C179.712 25.6256 178.335 21.9044 175.653 19.221L171.06 14.6266C170.404 13.9701 170.918 12.8514 171.844 12.9226L178.321 13.4207C182.104 13.7116 185.825 12.3354 188.509 9.65295L193.103 5.06015Z",
    fill: "#FC5726"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7025 124.337C30.5552 123.42 31.6277 122.815 32.3361 123.415L33.3588 124.281C36.2542 126.733 40.0763 127.798 43.8224 127.196L45.1457 126.983C46.0622 126.836 46.6673 127.909 46.0674 128.617L45.2012 129.64C42.7492 132.535 41.6844 136.357 42.2862 140.103L42.4988 141.427C42.6461 142.343 41.5736 142.948 40.8652 142.348L39.8425 141.482C36.9471 139.03 33.125 137.965 29.3789 138.567L28.0556 138.78C27.1391 138.927 26.534 137.855 27.1339 137.146L28.0001 136.123C30.4521 133.228 31.5169 129.406 30.9151 125.66L30.7025 124.337Z",
    fill: "#FC5726"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M269.257 180.412C269.88 179.925 270.772 180.477 270.616 181.252C269.976 184.42 270.752 187.709 272.74 190.257C273.227 190.88 272.675 191.772 271.9 191.616C268.732 190.976 265.443 191.752 262.895 193.74C262.272 194.227 261.38 193.675 261.536 192.9C262.176 189.732 261.4 186.443 259.412 183.895C258.925 183.272 259.477 182.38 260.252 182.536C263.42 183.176 266.709 182.4 269.257 180.412Z",
    fill: "#FC5726"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_21",
    x: 90.7453,
    y: 49.7453,
    width: 136.234,
    height: 244.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_21"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_21",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_21",
    x: 186,
    y: 65,
    width: 146,
    height: 73.1067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.561458 0 0 0 0 0.0775225 0 0 0 0 0.000703245 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_21"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_21",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMessage);
export default __webpack_public_path__ + "static/media/mobile_message.78c044c31ffca27998a5289cc0fa407b.svg";
export { ForwardRef as ReactComponent };